/**
 * FreeTextScreen
 *
 * Open-ended input — lets the user share anything
 * specific about their situation, concerns, or expectations.
 * Optional — can be skipped.
 */

import React, { useState } from "react";
import { View, Text, ScrollView, TextInput } from "react-native";
import { EMBER } from "@louise/moon-ui/theme/tokens";
import WarmButton from "@louise/moon-ui/primitives/WarmButton";
import { useTranslations } from "@src/packages/i18n";
import { usePlanBuilder } from "../PlanBuilderContext";

type Props = {
  onNext: () => void;
};

export default function FreeTextScreen({ onNext }: Props) {
  const t = useTranslations();
  const { state, updateState } = usePlanBuilder();
  const [text, setText] = useState(state.freeText);

  const handleChange = (value: string) => {
    setText(value);
    updateState({ freeText: value });
  };

  return (
    <ScrollView
      contentContainerStyle={{ padding: 24, paddingBottom: 40 }}
      showsVerticalScrollIndicator={false}
    >
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 22,
          fontWeight: "700",
          color: EMBER.colors.text,
          lineHeight: 28,
          marginBottom: 8,
        }}
      >
        {t("plan_builder.free_text.title")}
      </Text>
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 15,
          fontWeight: "400",
          color: EMBER.colors.textLight,
          lineHeight: 22,
          marginBottom: 24,
        }}
      >
        {t("plan_builder.free_text.subtitle")}
      </Text>

      <TextInput
        className="font-dm-sans"
        style={{
          borderWidth: 1,
          borderColor: EMBER.colors.border,
          borderRadius: 12,
          paddingHorizontal: 16,
          paddingVertical: 14,
          fontSize: 15,
          color: EMBER.colors.text,
          minHeight: 140,
          textAlignVertical: "top",
          lineHeight: 22,
        }}
        multiline
        placeholder={t("plan_builder.free_text.placeholder")}
        placeholderTextColor={EMBER.colors.textFaint}
        value={text}
        onChangeText={handleChange}
        maxLength={2000}
      />

      <Text
        className="font-dm-sans"
        style={{
          fontSize: 12,
          fontWeight: "400",
          color: EMBER.colors.textFaint,
          textAlign: "right",
          marginTop: 6,
          marginBottom: 20,
        }}
      >
        {t("plan_builder.free_text.char_count", {
          params: { current: String(text.length), max: "2000" },
        })}
      </Text>

      {/* Continue */}
      <WarmButton
        title={
          text.trim()
            ? t("plan_builder.continue")
            : t("plan_builder.free_text.skip")
        }
        onPress={onNext}
      />
    </ScrollView>
  );
}
